/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useSelector } from 'react-redux';

import { MobileMenuAccountPanel } from './MobileMenuAccountPanel';
import type { MenuAccountItemsType, ReduxStore } from './Navbar.types';

interface MobileMenuSignInOrAccountPanelProps {
    menuAccountItems: MenuAccountItemsType;
    isGuestAllowed?: boolean;
    isGuest: boolean;
}

export function MobileMenuSignInOrAccountPanel({
    menuAccountItems,
    isGuestAllowed,
    isGuest,
}: MobileMenuSignInOrAccountPanelProps) {
    // Redux state
    const account = useSelector((state: ReduxStore) => state.auth.account?.account);

    return (
        <MobileMenuAccountPanel
            isCommercialAccount={account ? account.is_commercial_account : false}
            hideBottomSignOut
            menuAccountItems={menuAccountItems}
            isGuest={isGuest}
            isLogged={!!account}
            isGuestAllowed={isGuestAllowed}
        />
    );
}
